<script lang="ts">
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_config } from 'src/configs/devices';
	import type { Device } from 'src/types/Device.ts';
	import InputsReaderVisualizerV2 from 'src/components/Controls/Indicators/InputsReaderVisualizerV2.svelte';
	import DeviceViewStateWrapper from '../DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import { getGen1DeviceStatuses } from '../../SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';
	import { peekOnlyStatusSlots, resolveSidepanelStatusSlots } from 'src/helpers/sidepanel_status_slots';
	import SidepanelStatusPeek from 'src/components/Sidepanel/SidepanelStatusPeek.svelte';

	export let device: Device;

	$: deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: statusSlots = peekOnlyStatusSlots(resolveSidepanelStatusSlots(device, _statuses));
	$: showStatusPeek = statusSlots.peek.length > 0;
</script>

<DeviceViewStateWrapper
	{device}
	hideSlotStaticBottom
	hideSlotFloatingBottom={!showStatusPeek}
>
	<div class="label-list-wrapper mb-s" slot="staticTop">
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>

	<div class="flex-full-height align-items-center justify-content-center" slot="content">
		<InputsReaderVisualizerV2 {device} {status} {settings} isInCard={false} />
	</div>

	<svelte:fragment slot="floatingBottom">
		{#if showStatusPeek}
			<SidepanelStatusPeek showMain={false} main={statusSlots.main} peek={statusSlots.peek} />
		{/if}
	</svelte:fragment>
</DeviceViewStateWrapper>
